define([
        "!!../../../node_modules/html-loader/dist/cjs.js??ref--26-1!./vimeo.html", 
        "!../../webpack/runtime/htmlExposer.js"], function (content, expose) {
            content = content.__esModule ? content.default : content;
            expose(content);
            return content;
        });